/* 
Menu Types:
"menu-default", "menu-sub-hidden", "menu-hidden"
*/
export const defaultMenuType = 'menu-sub-hidden';

export const subHiddenBreakpoint = 1440;
export const menuHiddenBreakpoint = 768;

export const searchPath = '#';

export const policyRetryMaxTries = 3;
export const policyRetryDelayLength = 2000 * 10;

export const themeColorStorageKey = '__theme_selected_color';
export const isMultiColorActive = true;
export const defaultColor = 'light.blueyale';
export const isDarkSwitchActive = true;
export const defaultDirection = 'ltr';
export const themeRadiusStorageKey = '__theme_radius';
export const isDemo = false;
export const colors = [
  'bluenavy',
  'blueyale',
  'blueolympic',
  // 'greenmoss',
  // 'greenlime',
  // 'purplemonster',
  // 'orangecarrot',
  // 'redruby',
  // 'yellowgranola',
  // 'greysteel',
];

export const userStorageKey = process.env.REACT_APP_GATEWAY + "/gb-api_user_storage";

export const UPLOAD_FILE_MAX_SIZE_ALLOWED_MB = 5; //(1024 * 1024 * 5 = 5.242.880 Bytes)
export const UPLOAD_FILE_EXTENSIONS_IMAGES_ALLOWED = ["image/jpeg", "image/png", "application/pdf"];

export const TipoExclusao = {
  Digital: 2,
  Fisica: 1
};

/**
 * Códigos mapeados para identificação dos tipos de documentos
 * Mesmos códigos utilizados na comunicação do GBOEX Online e projeto API-Smartshare
 */
export const TipoDocumento = {
  FormAlteracaoBeneficiarios: 1,
  FormSolicitacaoResgate: 2,
  FormCancelamentoProposta: 3,
  FormAvisoSinistro: 4,
  SelfieAlteracaoBeneficiarios: 5,
  DocIdentidadeAssociadoAltBeneficiarios: 6,
  CertidaoObito: 7,
  ComprovanteEndereco: 8,
  ComprovanteBancario: 9,
  Procuracao: 10,
  DocIdentidadeProcurador: 11,
  EscrituraHerdeiros: 12,
  DocIdentidadeHerdeiro: 13,
  CertidaoObitoAssociado: 14,
  CertidaoCivilHerdeiro: 15,
  CertidaoCuratela: 16,
  DocIdentidadeCurador: 17,
  SelfieCancelamento: 18,
  DocIdentidadeAssociadoResgate: 19,
  DocIdentidadeAssociadoCancelamento: 20
}

export const GrupoProduto = {
  PlanoTaxaMedia: 1
}

export const TIPO_SORTEIO_PROMOCAO_NORMAL = 1;
export const TIPO_SORTEIO_PROMOCAO_AUTOMATICA = 2;